import { Box, Heading, Text } from '@wix/design-system';
import { FeaturesGrid as PlatformFeaturesGrid } from '@wix/premium-purchase-platform/@components';
import {
  CreativeOffer,
  PurchaseOffering,
} from '@wix/premium-purchase-platform/@sdk';
import React from 'react';
import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';
import { FeaturesGridFeatureRow } from './FeaturesGridFeatureRow';

interface FeaturesGridSectionProps {
  group: CreativeOffer.GridNamespace;
  products?: PurchaseOffering.PurchaseProduct[];
}

export const FeaturesGridSection = ({
  group,
  products,
}: FeaturesGridSectionProps) => {
  const { t } = EclipsePackagePickerModule.internals.useTranslations();

  return (
    <PlatformFeaturesGrid.Content.Section.Root>
      <PlatformFeaturesGrid.Content.Section.Header
        labels={{
          open: t('Advanced.Plans_General_Show_features'),
          close: t('Advanced.Plans_General_Hide_features'),
        }}
        onToggle={(action) => {
          EclipsePackagePickerModule.internals.bi.onToggleFeatureGroup?.({
            groupKey: group.content?.name?.translationKey,
            action: action === 'open' ? 'open' : 'close',
          });
        }}
      >
        <Box direction="vertical">
          <Heading size="small">
            {t(group.content?.name?.translationKey ?? '')}
          </Heading>
          <Text size="small">
            {t(group.content?.description?.translationKey ?? '')}
          </Text>
        </Box>
      </PlatformFeaturesGrid.Content.Section.Header>
      <PlatformFeaturesGrid.Content.Section.Content>
        {group.features?.map((feature) => (
          <FeaturesGridFeatureRow
            key={feature.id}
            feature={feature}
            products={products}
          />
        ))}
      </PlatformFeaturesGrid.Content.Section.Content>
    </PlatformFeaturesGrid.Content.Section.Root>
  );
};
